interface Props {
  className?: string
}

export function Copyright(props: Props): JSX.Element {
  return (
    <p className={props.className}>
      © <Year /> Lucent Health Solutions, Inc
    </p>
  )
}

function Year(): JSX.Element {
  const now = new Date()
  const start = 2022
  const year = now.getFullYear()

  if (year === start) {
    return <span>{year}</span>
  }

  return (
    <span>
      {start}–{year}
    </span>
  )
}
